import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import { Footer } from '../common/footerbar';
import { Icon, Menu, ActivityIndicator, Toast } from 'antd-mobile';
import { PacksItems } from './item';
import { More } from './more';
import * as fun from '../../components/common';
import * as services from '../projects/services';
import imgURL from '../../res/images/logo.png';
import '../package/style.less';
import "../../utils/tool.jsx";
let page = 1;
let rows = 10;
let total = 0;
let firstShow = true;

let parameter =
{
    mcno: '',//体检中心编码
    level: '',//医院等级
    startprice: '',//价格区间，开始价格
    endprice: '',//价格区间，结束价格
    rows: rows,
    page: page,
    city: ''
};
let typeidlist = [];//体检套餐类型
let sylist = 0;//适用人群
let tslist = 0;//特色项目
let levelData = [{ value: '0', label: '全部' }];
let hospitalData = [{ value: '0', label: '全部' }];
let crowdData = [{ value: '0', label: '全部' }];
let screeningData = [{ value: '0', label: '全部' }];
let priceData = [{ startprice: '5000', endprice: '' }, { startprice: '4000', endprice: '4999' }, { startprice: '3000', endprice: '3999' }, { startprice: '2000', endprice: '2999' }, { startprice: '1000', endprice: '1999' }, { startprice: '1', endprice: '999' }];
export default class PacksList extends Component {
    constructor(props) {
        super(props);
        if (!window.globalvariable.getStore('cityid')) {
            window.globalvariable.setStore('cityid', global.constants.cityid);
        }
        page = 1;
        rows = 10;
        total = 0;
        firstShow = true;
        levelData = [{ value: '0', label: '全部' }];
        hospitalData = [{ value: '0', label: '全部' }];
        crowdData = [{ value: '0', label: '全部' }];
        screeningData = [{ value: '0', label: '全部' }];
        priceData = [{ startprice: '5000', endprice: '' }, { startprice: '4000', endprice: '4999' }, { startprice: '3000', endprice: '3999' }, { startprice: '2000', endprice: '2999' }, { startprice: '1000', endprice: '1999' }, { startprice: '1', endprice: '999' }];
        parameter =
            {
                mcno: '',//体检中心编码
                level: '',//医院等级
                startprice: '',//价格区间，开始价格
                endprice: '',//价格区间，结束价格
                rows: rows,
                page: page,
                city: window.globalvariable.getStore('cityid')
            };

        this.state = {
            parameter: parameter,
            show: false,
            item: '',
            levelC: '',
            hospitalC: '',
            crowdC: '',
            priceC: null,
            tsC: null,
            packData: [],
            levelData: levelData,
            hospitalData: hospitalData,
            crowdData: crowdData,
            screeningData: screeningData,
            priceData: priceData
        }
        typeidlist = [sylist, tslist];

    }

    //初次渲染
    componentDidMount() {
        let url = global.constants.wx_tijian + this.props.match.url;
         fun.wxshare(url, '体检套餐推荐-全人·健康', '自定义项目、体检套餐选择、基因检测、防癌早查，预约体检推荐。', imgURL);

        localStorage.removeItem('orderment');
        services.GetPacklist(parameter, typeidlist, '正在查询，请稍后').then(value => {
            if (value.status === 0) {
                total = value.result.total;
                this.setState({
                    packData: value.result.rows,
                });
                firstShow = false;
            } else {
                Toast.offline(value.message);
            }

        })
        this.GetTreelist();
        this.GetList();
        this.GetPackTypelist(1);
        this.GetPackTypelist(2);

        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total / rows >= page) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }

            timeCount = setTimeout(callback, 50);
        }.bind(this), false);
    }
    //获取医院等级
    GetList = () => {
        services.GetList('等级', false).then(level => {
            if (level.status === 0) {
                level.result.forEach(element => {
                    levelData.push({ value: element.code, label: element.name });
                });
            } else {
                Toast.offline(level.message);
            }

        })
    }
    //获取体检中心列表
    GetTreelist = () => {
        services.GetTreelist(window.globalvariable.getStore('cityid'), false).then(hospital => {
            if (hospital.status === 0) {
                hospital.result.forEach(element => {
                    hospitalData.push({ value: element.mcno, label: element.mcname });
                });
            }
        })
    }
    //获取特色项目和适用人群
    GetPackTypelist = (typeid) => {
        services.GetPackTypelist(typeid, false).then(e => {
            if (typeid === 1) {
                e.result.forEach(element => {
                    crowdData.push({ value: element.packtypeid, label: element.typename });
                });
            } else {
                e.result.forEach(element => {
                    screeningData.push({ value: element.packtypeid, label: element.typename });
                });
            }
        })
    }
    GetPacklist = () => {
        services.GetPacklist(parameter, typeidlist, '正在查询，请稍后').then(value => {
            total = value.result.total;
            this.setState({
                packData: value.result.rows,
            });
        })
    }
    //再次加载
    loadMoreDataFn = (page) => {
        parameter.page = page;
        this.setState({
            parameter: parameter,
        });
        services.GetPacklist(parameter, typeidlist, '正在查询，请稍后').then(value => {
            total = value.result.total;
            this.setState({
                packData: this.state.packData.concat(value.result.rows)
            });
        })
    }
    //取消选择
    onCancel = () => {
        this.setState({
            show: false,
            style: 0,
        });
    }
    levelClick = (e) => {
        window.scrollTo(0, 0);
        this.setState({
            item: 'level'
        });
        if (this.state.style !== 1) {
            this.setState({
                show: true,
                style: 1,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    HospitalClick = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.setState({
            item: 'hospital'
        });
        if (this.state.style !== 2) {
            this.setState({
                show: true,
                style: 2,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    crowdClick = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.setState({
            item: 'crowd'
        });
        if (this.state.style !== 3) {
            this.setState({
                show: true,
                style: 3,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    enableClick = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.setState({
            item: 'more'
        });
        if (this.state.style !== 4) {
            this.setState({
                show: true,
                style: 4,
            });
        } else {
            this.setState({
                show: false,
                style: 0,
            });
        }
    }
    onOK = (value, evalue) => {

        parameter.page = 1;
        if (parseInt(value) === 1) {

            if (parseInt(evalue) === 0) {
                parameter.level = '';
                this.setState({
                    parameter: parameter,
                });

            } else {
                parameter.level = evalue;
                this.setState({
                    parameter: parameter,
                });
            }
            this.setState({ levelC: evalue });
        } else if (parseInt(value) === 2) {
            if (parseInt(evalue) === 0) {
                parameter.mcno = '';
                this.setState({
                    parameter: parameter,
                });

            } else {
                parameter.mcno = evalue;
                this.setState({
                    parameter: parameter,
                });
            }
            this.setState({ hospitalC: evalue });
        }
        else if (parseInt(value) === 3) {
            if (parseInt(evalue) === 0) {
                typeidlist = [tslist];

                this.setState({
                    parameter: parameter,
                });

            } else {
                typeidlist = [];
                sylist = evalue;
                typeidlist = [sylist, tslist];
                this.setState({
                    parameter: parameter,
                });
            }
            this.setState({ crowdC: evalue });
        }
        this.onCancel();
        page = 1;
        this.GetPacklist();
    }
    onOkMore = (price, ts) => {
        parameter.page = 1;
        this.setState({ tsC: ts, priceC: price }, () => {
        });
        if (price != null) {
            parameter.startprice = priceData[price].startprice;
            parameter.endprice = priceData[price].endprice;
        } else {
            parameter.startprice = '';
            parameter.endprice = '';
        }
        if (ts != null) {
            tslist = screeningData[ts].value;
            typeidlist = [];
            typeidlist = [sylist, tslist];
        } else {
            tslist = null;
            typeidlist = [];
            typeidlist = [sylist, tslist];
        }
        this.onCancel();
        page = 1;
        this.GetPacklist();
    }
    render() {
        const { show, item } = this.state;
        let initData;
        var menuEl;
        if (item === 'level') {
            initData = this.state.levelData;
            menuEl = (
                <Menu
                    className="single-foo-menu"
                    data={this.state.levelData}
                    value={this.state.levelC}
                    level={0}
                    onChange={this.onOK.bind(this, '1')}
                    height={document.documentElement.clientHeight * 0.6}
                />
            );
        } else if (item === 'hospital') {
            initData = this.state.hospitalData;
            menuEl = (
                <Menu
                    className="single-foo-menu"
                    data={this.state.hospitalData}
                    value={this.state.hospitalC}
                    level={0}
                    onChange={this.onOK.bind(this, '2')}
                    height={document.documentElement.clientHeight * 0.6}
                />
            );
        } else if (item === 'crowd') {
            initData = this.state.crowdData;
            menuEl = (
                <Menu
                    className="single-foo-menu"
                    data={this.state.crowdData}
                    value={this.state.crowdC}
                    level={0}
                    onChange={this.onOK.bind(this, '3')}
                    height={document.documentElement.clientHeight * 0.6}
                />
            );
        } else if (item === 'more') {
            initData = this.state.crowdData;
            menuEl = <More
                onOkMore={this.onOkMore}
                onCancel={this.onCancel}
                priceData={this.state.priceData}
                screeningData={this.state.screeningData}
                priceC={this.state.priceC}
                tsC={this.state.tsC}
            />;
        }
        const loadingEl = (
            <div style={{ position: 'absolute', width: '100%', height: document.documentElement.clientHeight * 0.6, display: 'flex', justifyContent: 'center' }}>
                <ActivityIndicator size="large" />
            </div>
        );
        return (<div className="package">
            <div className={show ? 'single-menu-active' : ''}>
                <CommonlyHead barname='体检套餐' />
                <div className="filterbox">
                    <div className='filter'>
                        <div className="filter-item" key="1" onClick={this.levelClick} ><div style={{ color: this.state.style !== 1 ? '' : '#2fb992' }}>
                            <span>{'医院等级'}</span><Icon type={this.state.style !== 1 ? 'down' : 'up'} size="xxs" /></div></div>
                        <div className="filter-item" key="2" onClick={this.HospitalClick}><div style={{ color: this.state.style !== 2 ? '' : '#2fb992' }}>
                            <span>{'体检中心'}</span><Icon type={this.state.style !== 2 ? 'down' : 'up'} size="xxs" /></div></div>
                        <div className="filter-item" key="3" onClick={this.crowdClick}><div style={{ color: this.state.style !== 3 ? '' : '#2fb992' }}>
                            <span>{'适用人群'}</span><Icon type={this.state.style !== 3 ? 'down' : 'up'} size="xxs" /></div></div>
                        <div className="filter-item" key="4" onClick={this.enableClick}><div style={{ color: this.state.style !== 4 ? '' : '#2fb992' }}>
                            <span>{'筛选'}</span><Icon type={this.state.style !== 4 ? 'down' : 'up'} size="xxs" /></div></div>
                    </div>
                </div>
                <div className="menu">
                    {show ? initData ? menuEl : loadingEl : null}
                    {show ? <div className="menu-mask" onClick={this.onCancel} /> : null}
                </div>
                {total === 0 && firstShow === false ?
                    <div className="errordiv"><img alt='' src={require('../../res/images/zwsj.png')} />
                        <p>对不起，没有找到您要的信息，请重新筛选</p>
                    </div>
                    : ''}
                <div className="itemlist">
                    {this.state.packData.map((data, index) => (<PacksItems packData={data} key={index} type={'p'} />))}
                    <div ref="wrapper"></div>
                </div>
                <Footer selectedTab='package' />
            </div>
        </div>);
    }
}